import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useDispatch} from 'react-redux';
import {clearCashAppRecipient, approveCashAppOrder} from '../../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';
import Copy from '../../../../components/copy';
import LoaderPage from '../../../../components/loader_page';


export default ({data, onPayment, order}) => {
    const dispatch = useDispatch(),
          navigate = useNavigate();

    if(!order)
        return <LoaderPage />

    return (
        <>
            <div className="page-title">CashApp</div>
            <div className="page-descriptions">
                Send <b>${data.amount}</b> as <b>Bitcoin Gift</b> to the recipient <b>{order.receiver.cashtag}</b> and click the «Payment Made» button to process the request
            </div>


            <div className="amount_input">
                <div className="label">Transfer</div>
                <div className="amount">
                    <div className="symbol">$</div>
                    <div className="value">{data.amount}</div>
                </div>
            </div>

            <div className="cashapp_receiver">
                <div className="label">To recipient</div>
                <div className="user">
                    <div className="avatar">
                        <img src="../../../images/default_avatar.png" />
                    </div>
                    <div className="details">
                        <div className="cashtag">{order.receiver.cashtag}</div>
                        <div className="name">{order.receiver.name}</div>
                    </div>
                    <Copy value={order.receiver.cashtag} fill="#A8D81A" size={24} />
                </div>
            </div>

            <div className="mt20"></div>
            <div className="button blue" onClick={e => {
                dispatch(approveCashAppOrder(order.paymentId));
                onPayment();
            }}>Payment made</div>

            <div className="button" onClick={e => {
                dispatch(clearCashAppRecipient());
                navigate('/');
            }}>Cancel payment</div>
        </>
    )
}